import { useGlobalStore } from '@sunrise/shared'
import { RequestContext } from '@sunrise/types'

import { EstateType } from '../mapper/decoratedEstateDetailMapper.enum'
import { OfferType } from '../service/realEstateService.enum'
import { UrlPath } from './resultListLink.enum'

export function buildResultListUrl(offerType: OfferType, estateType: EstateType): string {
    const requestContext = useGlobalStore().requestContext
    const origin = getUrlOrigin(requestContext)
    const location = getLocation(requestContext)
    const urlPath = determineUrlPath(offerType, estateType)

    return `${origin}/${location}/immobilien/${urlPath}`
}

function determineUrlPath(offerType: OfferType, estateType: EstateType): UrlPath {
    if (offerType == OfferType.RENT && estateType == EstateType.APARTMENT) {
        return UrlPath.APARTMENT_RENT
    } else if (offerType == OfferType.RENT && estateType == EstateType.HOUSE) {
        return UrlPath.HOUSE_RENT
    } else if (offerType == OfferType.SELL && estateType == EstateType.APARTMENT) {
        return UrlPath.APARTMENT_SELL
    } else if (offerType == OfferType.SELL && estateType == EstateType.HOUSE) {
        return UrlPath.HOUSE_SELL
    } else if (offerType == OfferType.SELL && estateType == EstateType.PROPERTY) {
        return UrlPath.PROPERTY_SELL
    } else if (offerType == OfferType.RENT && estateType == EstateType.PROPERTY) {
        return UrlPath.PROPERTY_RENT
    } else if (offerType == OfferType.RENT && estateType == EstateType.GARAGE) {
        return UrlPath.GARAGE_RENT
    } else if (
        estateType == EstateType.OFFICE ||
        estateType == EstateType.RETAIL_TRADE ||
        estateType == EstateType.HALL ||
        estateType == EstateType.HOSPITALITY ||
        estateType == EstateType.AGRONOMY_SIDE
    ) {
        return UrlPath.COMMERCIAL_REAL_ESTATE
    } else {
        return UrlPath.DEFAULT
    }
}

function getUrlOrigin(requestContext?: RequestContext): string {
    return requestContext?.url.origin || ''
}

function getLocation(requestContext?: RequestContext): string {
    return requestContext?.location.id || 'deutschland'
}
